import { render } from "./ArtistsView.vue?vue&type=template&id=7bd6774d&scoped=true&ts=true"
import script from "./ArtistsView.vue?vue&type=script&lang=ts"
export * from "./ArtistsView.vue?vue&type=script&lang=ts"

import "./ArtistsView.vue?vue&type=style&index=0&id=7bd6774d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd6774d"]])

export default __exports__